import { Box, TextField } from '@material-ui/core';
import { State, WorkflowParams } from '@sierralabs/workflow';

import ElectronicSignatureDialog from '../../../electronic-signature/ElectronicSignatureDialog';
import { TaskContext } from '../../../tasks/Task.machine';
import {
  TransitionConditionConfiguratorProps,
  TransitionConditionDisplayProps,
  TransitionConditionPlugin
} from '../TransitionConditionPlugin';

const SignatureConfigurator: React.FC<
  TransitionConditionConfiguratorProps
> = props => {
  const { condition, onChange } = props;
  return (
    <>
      <Box mt={2}>
        <TextField
          fullWidth
          multiline
          label='Reason'
          variant='outlined'
          value={condition.params?.reason || ''}
          onChange={event => {
            if (condition.params) {
              condition.params.reason = event.target.value;
              onChange?.({ ...condition });
            }
          }}
        />
      </Box>
      <Box mt={2}>
        <TextField
          fullWidth
          multiline
          label='Meaning'
          variant='outlined'
          value={condition.params?.meaning || ''}
          onChange={event => {
            if (condition.params) {
              condition.params.meaning = event.target.value;
              onChange?.({ ...condition });
            }
          }}
        />
      </Box>
      <Box mt={2}>
        <TextField
          fullWidth
          multiline
          variant='outlined'
          label='Reason Field Label'
          helperText='Leave empty to hide reason field input.'
          value={condition.params?.reasonLabel || ''}
          onChange={event => {
            if (condition.params) {
              condition.params.reasonLabel = event.target.value;
              onChange?.({ ...condition });
            }
          }}
        />
      </Box>
    </>
  );
};

const SignatureDisplay: React.FC<TransitionConditionDisplayProps> = () => {
  return <>Electronic Signature</>;
};

export interface SignatureParams extends WorkflowParams {
  meaning: string;
  reason: string;
  reasonLabel: string;
}

export const SignaturePlugin: TransitionConditionPlugin<SignatureParams> = {
  type: 'signature',
  label: 'Electronic Signature',
  configurator: SignatureConfigurator,
  display: SignatureDisplay,
  validate: () => true,
  guard: (state: State<TaskContext>, params, render) => {
    console.debug('guards: signature', state, params);
    state.context.reason = params.reasonLabel;
    if (
      state.isSimulation ||
      state.context.skipTransitionConditionPlugins?.includes(
        SignaturePlugin.type
      )
    ) {
      return true;
    } else if (!render) return false;
    return new Promise(resolve => {
      render(
        <ElectronicSignatureDialog
          open
          meaning={params.meaning || ''}
          reasonLabel={params.reasonLabel}
          onCancel={() => {
            render(undefined);
            resolve(false);
          }}
          onSigned={reason => {
            // add reason to task
            if (typeof reason !== 'undefined') {
              state.context.reason = reason;
            }
            render(undefined);
            resolve(true);
          }}
        />
      );
    });
  }
};
